export default __webpack_public_path__ + "assets/images/OA Sash Arrow_Bhood.png";